module.exports = __webpack_public_path__ + "static/img/glasses_01.4499f10.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/glasses_01.png
// module id = bqXO
// module chunks = 0